var file_upload_viewer_default = {
  "fontElementMap": "_1m8nE",
  "file_upload_container": "h-NjN",
  "file_upload_error_container": "mY-Ib",
  "file_upload_link": "sqJYA",
  "width_three": "mikLm",
  "file_upload_text_container": "Kyykf",
  "width_two": "PdyHG",
  "file_upload_state": "sJTTD",
  "mobile_status_icon": "oOnqG",
  "file_upload_name_container": "SsroX",
  "file_upload_name": "-z-k2",
  "file_upload_extension": "qC3ni",
  "width_one": "mn-Va",
  "file_upload_type_icon": "-EBw3",
  "file_loader_icon": "_7PPsT",
  "spin": "ajnzl",
  "file_upload_type": "_80Kcb",
  "file_upload_text_error": "fLb-S",
  "file_upload_icon_frame": "J3RbZ",
  "file_upload_icon_background": "H4At8"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
